export const categories = [
  { slug: "love", name: "恋爱", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "热血", icon: "ri-fire-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "daily", name: "日常", icon: "ri-sun-line" },
  { slug: "school", name: "校园", icon: "ri-book-open-line" },
  { slug: "historical", name: "古风", icon: "ri-flag-line" },
  { slug: "bl", name: "耽美", icon: "ri-star-line" },
];

export const comics = [
  {
    id: 1,
    slug: "secretarys-revenge",
    title: "秘书的逆袭",
    author: "金秀雅",
    category: "love",
    rating: 9.6,
    status: "连载中",
    chapters: 87,
    views: "326万",
    description: "平凡的女秘书林小雅在被上司无情辞退后，意外获得了神秘集团继承人的青睐。当她以全新身份重返职场，曾经轻视她的人才发现，这个看似柔弱的女孩，掌握着足以颠覆整个行业的秘密。一场关于复仇与成长的华丽逆袭，就此展开。",
    updateTime: "2026-08-04",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20cover%20art%2C%20romance%20style%2C%20beautiful%20female%20office%20worker%20in%20stylish%20suit%2C%20modern%20Seoul%20office%20background%2C%20soft%20warm%20lighting%2C%20watercolor%20and%20ink%20illustration%20style%2C%20clean%20composition%2C%20minimalist%20design%20with%20Korean%20aesthetic%2C%20gentle%20color%20palette%20of%20peach%20and%20cream&width=400&height=560&seq=comic-cover-01&orientation=portrait",
  },
  {
    id: 2,
    slug: "magic-academy-genius",
    title: "魔法学院的吊车尾天才",
    author: "李正洙",
    category: "fantasy",
    rating: 9.8,
    status: "连载中",
    chapters: 124,
    views: "512万",
    description: "被誉为史上最差魔法师的他，其实体内封印着上古龙神之力。在帝国最顶级的魔法学院里，他以吊车尾的身份入学，却每一次危机都能展现出惊人的实力。当黑暗势力逼近，这个隐藏身份的少年的真实面目，终将震惊天下。",
    updateTime: "2026-08-05",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20fantasy%20magic%20academy%20theme%2C%20young%20male%20student%20in%20magic%20robe%2C%20magical%20sparks%20and%20ancient%20runes%20floating%2C%20castle%20academy%20silhouette%20background%2C%20dramatic%20warm%20golden%20light%2C%20illustration%20style%20with%20rich%20textures%2C%20Korean%20manhwa%20aesthetic&width=400&height=560&seq=comic-cover-02&orientation=portrait",
  },
  {
    id: 3,
    slug: "underworld-boss-fell-for-me",
    title: "黑道大佬看上我了",
    author: "朴恩智",
    category: "love",
    rating: 9.5,
    status: "已完结",
    chapters: 96,
    views: "489万",
    description: "在便利店的深夜打工中，她随手递给了一个受伤的陌生男人一罐咖啡。没想到，这个看似落魄的男人，竟是掌控整个城市地下秩序的黑道帝王。从那一刻起，她的平凡人生被彻底改写。",
    updateTime: "2026-08-03",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20romantic%20drama%20style%2C%20mysterious%20handsome%20man%20in%20dark%20suit%20and%20gentle%20female%20protagonist%2C%20night%20city%20neon%20light%20background%2C%20dramatic%20contrast%20lighting%2C%20illustration%20with%20rich%20dark%20tones%20and%20warm%20highlights&width=400&height=560&seq=comic-cover-03&orientation=portrait",
  },
  {
    id: 4,
    slug: "solo-leveling-destiny",
    title: "独步成神",
    author: "崔志浩",
    category: "action",
    rating: 9.9,
    status: "连载中",
    chapters: 156,
    views: "892万",
    description: "在世界各地突然出现的神秘传送门中，魔物蜂拥而出。被称为最弱E级猎人的成振宇，在一次几乎全军覆没的双重地下城探险中，获得了神秘的「系统」能力。从最弱到最强，他的每一步都震撼着整个世界。",
    updateTime: "2026-08-05",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20action%20fantasy%20style%2C%20powerful%20male%20warrior%20with%20dark%20armor%20and%20glowing%20blue%20eyes%2C%20portal%20and%20monster%20silhouettes%20background%2C%20epic%20cinematic%20lighting%2C%20dynamic%20composition%2C%20dark%20and%20dramatic%20illustration%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait",
  },
  {
    id: 5,
    slug: "mystery-neighbor",
    title: "隔壁的谜团",
    author: "尹美来",
    category: "thriller",
    rating: 9.4,
    status: "连载中",
    chapters: 52,
    views: "198万",
    description: "新搬来的邻居似乎永远不出门，但他的房间里每天都会传出不同女性的笑声。好奇心驱使她去探究真相，却没想到一步步踏入了精心布置的陷阱。当真相浮出水面，她发现自己早已是局中人。",
    updateTime: "2026-08-02",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20mystery%20thriller%20style%2C%20suspicious%20apartment%20door%20with%20light%20seeping%20through%2C%20female%20protagonist%20looking%20concerned%2C%20dark%20corridor%20with%20shadows%2C%20tense%20atmosphere%2C%20muted%20color%20palette%20with%20single%20warm%20light%20source&width=400&height=560&seq=comic-cover-05&orientation=portrait",
  },
  {
    id: 6,
    slug: "campus-sweetheart",
    title: "校园甜心",
    author: "宋智恩",
    category: "school",
    rating: 9.3,
    status: "已完结",
    chapters: 68,
    views: "275万",
    description: "转学到新学校的她，第一天就惹上了全校最受欢迎的校草。两人从水火不容到相知相惜，在青春洋溢的校园生活中，谱写了一段令人心动的甜蜜恋曲。",
    updateTime: "2026-07-28",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20school%20romance%20style%2C%20cheerful%20students%20in%20school%20uniform%2C%20cherry%20blossom%20campus%20background%2C%20bright%20spring%20sunlight%2C%20sweet%20and%20fresh%20illustration%20style%2C%20soft%20pastel%20color%20palette&width=400&height=560&seq=comic-cover-06&orientation=portrait",
  },
  {
    id: 7,
    slug: "palace-phoenix",
    title: "宫阙凤还",
    author: "韩瑞英",
    category: "historical",
    rating: 9.7,
    status: "连载中",
    chapters: 103,
    views: "421万",
    description: "穿越到古代成为罪臣之女的她，凭借现代人的智慧与洞察，在步步惊心的宫廷斗争中化险为夷。从冷宫弃女到权倾天下的皇后，她的每一步都踏在刀尖之上。",
    updateTime: "2026-08-04",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20historical%20palace%20drama%20style%2C%20beautiful%20woman%20in%20traditional%20Korean%20hanbok%20royal%20dress%2C%20ancient%20palace%20courtyard%20background%2C%20golden%20warm%20lighting%2C%20elegant%20and%20refined%20illustration%20with%20intricate%20details&width=400&height=560&seq=comic-cover-07&orientation=portrait",
  },
  {
    id: 8,
    slug: "cat-diary",
    title: "猫系日常",
    author: "姜多熙",
    category: "daily",
    rating: 9.2,
    status: "连载中",
    chapters: 45,
    views: "156万",
    description: "独居女孩和她的三只猫的温馨日常。每一话都是独立的小故事，关于陪伴、关于治愈、关于在城市中寻找温暖。当你疲惫时，翻开这本漫画，让猫咪治愈你的心。",
    updateTime: "2026-08-01",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20slice%20of%20life%20style%2C%20cozy%20apartment%20with%20cats%20and%20young%20woman%2C%20warm%20sunlight%20through%20window%2C%20soft%20and%20healing%20atmosphere%2C%20gentle%20watercolor%20illustration%20style%2C%20cream%20and%20warm%20beige%20color%20palette&width=400&height=560&seq=comic-cover-08&orientation=portrait",
  },
  {
    id: 9,
    slug: "blood-brothers",
    title: "血盟兄弟",
    author: "金泰亨",
    category: "action",
    rating: 9.6,
    status: "连载中",
    chapters: 112,
    views: "368万",
    description: "两个孤儿院长大的少年，在首尔的街头摸爬滚打，一步步建立自己的势力。当他们站在权力顶峰时，却发现背后操控一切的，竟然是最信任的人。兄弟义气与热血战斗，谱写一曲荡气回肠的都市传奇。",
    updateTime: "2026-08-03",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20action%20street%20fighter%20style%2C%20two%20determined%20young%20men%20standing%20back%20to%20back%2C%20urban%20Seoul%20night%20street%20background%2C%20dramatic%20moody%20lighting%2C%20intense%20illustration%20with%20strong%20contrast%2C%20Korean%20manhwa%20action%20aesthetic&width=400&height=560&seq=comic-cover-09&orientation=portrait",
  },
  {
    id: 10,
    slug: "starlight-promise",
    title: "星光的约定",
    author: "林夏恩",
    category: "bl",
    rating: 9.8,
    status: "已完结",
    chapters: 78,
    views: "534万",
    description: "当红偶像与素人摄影师因一次意外拍摄相遇，从误解到理解，从合作到心动。在聚光灯下隐藏的秘密恋情，能否经得起万千目光的考验？两颗孤独的心在星光下许下的约定，是最美的爱情模样。",
    updateTime: "2026-07-15",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20romantic%20drama%20style%2C%20two%20handsome%20young%20men%20gazing%20at%20each%20other%20tenderly%2C%20starry%20night%20sky%20background%2C%20soft%20moonlight%20and%20dreamy%20atmosphere%2C%20beautiful%20ethereal%20illustration%20style%2C%20gentle%20blue%20and%20silver%20tones&width=400&height=560&seq=comic-cover-10&orientation=portrait",
  },
  {
    id: 11,
    slug: "reborn-as-villainess",
    title: "重生之恶役千金",
    author: "郑多彬",
    category: "fantasy",
    rating: 9.5,
    status: "连载中",
    chapters: 89,
    views: "412万",
    description: "一觉醒来发现自己穿进了最爱的恋爱游戏，还成了注定悲剧收场的恶役大小姐。为了避免死亡结局，她决定远离所有攻略对象。然而事与愿违，越是逃避，所有人反而越被她吸引。",
    updateTime: "2026-08-05",
    cover: "https://readdy.ai/api/search-image?width=400&height=560&seq=comic-cover-11&orientation=portrait&query=Korean%20manhwa%20cover%20art%2C%20fantasy%20romance%20style%2C%20elegant%20noblewoman%20in%20lavish%19th%20century%20dress%2C%20grand%20mansion%20ballroom%20background%2C%20sparkling%20chandelier%20lighting%2C%20rich%20and%20ornate%20illustration%20style%2C%20warm%20golden%20and%20rose%20tones",
  },
  {
    id: 12,
    slug: "midnight-cafe",
    title: "深夜咖啡馆",
    author: "柳河镇",
    category: "thriller",
    rating: 9.3,
    status: "连载中",
    chapters: 38,
    views: "123万",
    description: "只营业到深夜的咖啡馆，进来的每一位客人都有一个不为人知的秘密。而店长，似乎知晓所有人的故事。当秘密在咖啡的香气中缓缓浮现，你会发现，最可怕的故事，藏在最普通的人身上。",
    updateTime: "2026-08-04",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20mystery%20noir%20style%2C%20dim%20coffee%20shop%20interior%20with%20warm%20lamp%20light%2C%20mysterious%20barista%20silhouette%2C%20foggy%20window%20with%20night%20street%20reflection%2C%20atmospheric%20and%20moody%20illustration%2C%20dark%20brown%20and%20amber%20color%20palette&width=400&height=560&seq=comic-cover-12&orientation=portrait",
  },
];

export const featuredSlugs = [
  "secretarys-revenge",
  "magic-academy-genius",
  "solo-leveling-destiny",
  "palace-phoenix",
  "starlight-promise",
  "reborn-as-villainess",
];

export const popularSlugs = [
  "solo-leveling-destiny",
  "magic-academy-genius",
  "starlight-promise",
  "palace-phoenix",
  "underworld-boss-fell-for-me",
  "blood-brothers",
  "reborn-as-villainess",
  "secretarys-revenge",
];

export const latestSlugs = [
  "magic-academy-genius",
  "solo-leveling-destiny",
  "reborn-as-villainess",
  "palace-phoenix",
  "blood-brothers",
  "secretarys-revenge",
  "midnight-cafe",
  "cat-diary",
  "mystery-neighbor",
  "underworld-boss-fell-for-me",
];

export const faqItems = [
  {
    question: "韩漫之家上的漫画都是免费阅读的吗？",
    answer: "韩漫之家上的大部分漫画均为免费阅读，我们致力于为漫画爱好者提供优质的免费阅读体验。部分独家授权作品可能需要会员解锁，但我们每周都会更新大量免费章节。",
  },
  {
    question: "如何在韩漫之家找到我想看的漫画？",
    answer: "您可以通过首页的分类导航、搜索功能，或浏览热门推荐和最新更新来查找喜欢的漫画。我们的分类涵盖恋爱、奇幻、热血、悬疑等多种类型，满足不同读者的阅读偏好。",
  },
  {
    question: "韩漫之家的漫画多久更新一次？",
    answer: "不同作品的更新频率有所不同，热门连载通常保持每周更新。您可以在漫画详情页查看具体的更新日期，也可以关注喜欢的作品以获取更新提醒。",
  },
  {
    question: "韩漫之家的漫画可以在手机上阅读吗？",
    answer: "当然可以！韩漫之家完美适配手机、平板和电脑等各种设备，您可以在任何屏幕上享受流畅舒适的漫画阅读体验。",
  },
  {
    question: "如何向韩漫之家推荐漫画作品？",
    answer: "我们非常欢迎读者的推荐！您可以通过关于我们页面上的联系方式或站内意见反馈渠道，向我们推荐您喜爱的韩国漫画作品，我们会有专人审核评估。",
  },
];

export const testimonials = [
  {
    name: "漫画迷小陈",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20female%20avatar%20portrait%2C%20warm%20smile%2C%20simple%20cream%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish",
    rating: 5,
    comment: "韩漫之家是我每天必刷的网站，画质清晰，更新又快，真心推荐给所有韩漫爱好者！",
  },
  {
    name: "追更达人小李",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20male%20avatar%20portrait%2C%20friendly%20expression%2C%20clean%20minimal%20background%2C%20casual%20style%2C%20natural%20daylight%20photography&width=80&height=80&seq=avatar-02&orientation=squarish",
    rating: 5,
    comment: "分类非常齐全，想看的韩漫几乎都能找到。页面设计也很简洁，阅读体验超棒！",
  },
  {
    name: "漫画收藏家小王",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20female%20avatar%20portrait%2C%20glasses%2C%20intellectual%20look%2C%20warm%20tone%20lighting%2C%20simple%20studio%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish",
    rating: 5,
    comment: "用了好多漫画平台，还是韩漫之家最稳定。画质高清，加载快，已经安利给身边所有朋友了。",
  },
];

export const contactInfo = {
  email: "contact@hanmanzhijia.com",
  wechat: "韩漫之家官方",
  qq: "1234567890",
  address: "北京市朝阳区望京SOHO T3 15层",
  phone: "400-888-8888",
  workingHours: "周一至周五 9:00 - 18:00",
};